import { full } from "acorn-walk";
import MagicString from "magic-string";
import { parseScript } from "./parse.js";

// Run counters for the code view: every function body starts with __blRan("file:offset"), which
// the preview bridge counts, so cards can show "ran 12×" and light up as they run. The key is the
// function's offset in the student's original file, the same one analyzeFile() gives each card.
// No newlines are added, so line numbers in errors still match the student's file.

export function addRunCounters(code: string, file: string): { code: string; counted: number } {
  const { ast } = parseScript(code);
  if (!ast) return { code, counted: 0 };
  const s = new MagicString(code);
  let counted = 0;
  full(ast, (n) => {
    const fn = n as unknown as { type: string; start: number; body: { type: string; start: number; end: number } };
    if (fn.type !== "FunctionDeclaration" && fn.type !== "FunctionExpression" && fn.type !== "ArrowFunctionExpression") return;
    const key = JSON.stringify(`${file}:${fn.start}`);
    if (fn.body.type === "BlockStatement") {
      s.appendLeft(fn.body.start + 1, `__blRan(${key});`);
    } else {
      // Arrow function with an expression body: (__blRan(key), expression)
      s.appendRight(fn.body.start, `(__blRan(${key}), `);
      s.prependLeft(fn.body.end, ")");
    }
    counted++;
  });
  return { code: counted ? s.toString() : code, counted };
}
